import * as apiConstants from '../../constants/apiConstants';
import {createApiPath, createFetchAndCall} from '../fetch/fetchServices';


class EditAccountApi {
  static forgotPasswordReset(email) {
    let path = createApiPath(apiConstants.passwordResetApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'POST',
      headers: headers,
      body:JSON.stringify({
        mail : email
      })
    };
    return createFetchAndCall(path, options);
  }

  static updateUser(newInfo){
    let fields = Object.keys(newInfo);
    let body = {};
    fields.map((field)=>{
      if(field == "companyName")
      {
        body['company'] = {};
        body['company']['name'] = newInfo[field];
      } else if (field =="phoneNumber"){
        body['telephone']=newInfo[field];
      } else {
        body[field]=newInfo[field];
      }
    });
    let update_path = apiConstants.createUserApi + "/0";
    let path = createApiPath(update_path);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body:JSON.stringify(body)
    };
    return createFetchAndCall(path, options);
  }

  static refreshToken() {
    const path = createApiPath(apiConstants.refreshTokenApi);
    const headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    const options = {
      method: 'POST',
      headers: headers
    };
    return createFetchAndCall(path, options);
  }
}



export default EditAccountApi;



/** WEBPACK FOOTER **
 ** ./src/api/account/editAccountApi.js
 **/